import React, {useState, useEffect, useRef, useCallback, JSX } from 'react'
import Chart, { Grid as GridChart, CommonSeriesSettings, ArgumentAxis, Series, Legend, ValueAxis, ZoomAndPan, ScrollBar, Tooltip, TickInterval, Aggregation, Point, Title, AggregationInterval, Label, Height, Crosshair, Font, MinorTickInterval, Tick, MinorTick, Strip, CommonAxisSettings } from 'devextreme-react/chart';
import CardHeader from "components/Card/CardHeader.js";
import RangeSelector, {
    Size, Chart as ChartOptions, Margin, Scale, Behavior, RangeSelectorTypes,
} from 'devextreme-react/range-selector';
import moment, { Moment } from 'moment'
import { Grid, Tooltip as TooltipMUI } from '@mui/material';
import DateRange from '../../components/Dates/DateRange';
import { TextField, Chip, Button, Select, MenuItem, Checkbox } from "@mui/material"
import { CallGetAPI, CallPostAPI, CreateUrl } from '../../Utils/ApiHelper';
import { VisualRange } from 'devextreme-react/common/charts';
import ClipLoader from "react-spinners/ClipLoader";
import { Start } from '@mui/icons-material';
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import { useTheme } from '@mui/material/styles'
import { GraphTemplate, graphTemplateModel, GraphSettings, deepCopyAshridgeDefault } from '../../models/GraphTemplateModel'
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { UserSettings } from '../../models/APIUserSettingsModel'
import Modal from 'react-bootstrap/Modal'
import NumberField from '../CustomInput/NumberField'
import { MuiColorInput } from 'mui-color-input';
import Loader from '../../Utils/Loader/NewLoader2025'
import { adjustTime } from '../../Utils/AdjustTime'
import {
    MultiLoggerColumnData,
    loggerInfo,
    APISiteLoggerDetail,
    reloadData,
    handleCustomColorClick,
    AvgStyling
} from './MinimumNightFlowFunctions'
import MinimumNightFlowTrendModal from './MinimumNightFlowTrendModal'


interface Props {
    serial: number | null
    siteId: number | null
    loggerData: Array<APISiteLoggerDetail> | null
    startDateProps: Date
    endDateProps: Date
    showDateLink : boolean
}



interface PointData {
    dateTime?: string
    value?: number
    series?: string
}









  
 


const MinimumNightFlow: React.FC<Props> = ({ serial, siteId, loggerData, startDateProps, endDateProps, showDateLink }) => {
    const language = sessionStorage.getItem("language")
    if (language) {
        locale(language);
    }
    
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);



    const intl = useIntl()
    const theme = useTheme()
    const chartRef = useRef(null)
    const [graphData, setGraphData] = useState<Array<MultiLoggerColumnData>>([])
    const [startDate, setStartDate] = useState<Date>(adjustTime(moment().subtract(3, 'months').set({ hour: 0, minute: 0, second: 0 }).toDate()))
    const [endDate, setEndDate] = useState<Date>(adjustTime(moment().set({hour: 23, minute: 59, second: 59}).toDate()))
    const [visualRange, setVisualRange] = useState<VisualRange>({ startValue: startDate, endValue: endDate })
    const [loggers, setLoggers] = useState<Array<loggerInfo>>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [dateChange, setDateChange] = useState<boolean>(false)
    const [shouldReloadData, setShouldReloadData] = useState<boolean>(false)
    const [linkDates, setLinkDates] = useState<boolean>(false)
    const [reloadDataCount, setReloadDataCount] = useState<number>(0)
    const [useCustomColors, setUseCustomColors] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [averageStyling, setAverageStyling] = useState<AvgStyling>({ color: '#FF69B4', width: 2, showPoints: true, size: 5})
    const [tempAverageStyling, setTempAverageStyling] = useState<AvgStyling>(averageStyling)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [outputLoggers, setOutputLoggers] = useState<Array<number>>([])
    const [allValuesZero, setAllValuesZero] = useState<boolean>(true)
    const [pointData, setPointData] = useState<PointData>()
    const [trendModal, setTrendModal] = useState<boolean>(false)


    useEffect(() => {
        reloadData(
            setLoading,
            serial,
            startDate,
            endDate,
            setAllValuesZero,
            loggers,
            useCustomColors,
            setUseCustomColors,
            setLoggers,
            setGraphData,
            siteId,
            loggerData,
            setErrorMessage,
            setOutputLoggers,
            intl
        )
        
    }, [serial])

    useEffect(() => {
        if (showDateLink === false) {
            setLinkDates(false)
        } else if (showDateLink === true) {
            CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
                .then((data: UserSettings[]) => {
                    for (const userSetting of data) {
                        if (userSetting.settingsKey === 'Link Dates' && userSetting.settingsValue === 'true') {
                            setLinkDates(true)
                            setStartDate(startDateProps)
                            setEndDate(endDateProps)
                            setShouldReloadData(true)
                        }
                    }
                })
        }

    }, [showDateLink])


    useEffect(() => {
        if (reloadDataCount !== 0 && linkDates) {
            onDateChange(startDateProps, endDateProps, false, true)
        }
        setReloadDataCount(prev => prev +1)
    }, [startDateProps, endDateProps])


    useEffect(() => {
        CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
            .then((data: UserSettings[]) => {
                for (const userSetting of data) {
                    if (userSetting.settingsKey === 'Custom Average') {
                        const avgSett: AvgStyling = JSON.parse(userSetting.settingsValue)
                        avgSett.color = `#${avgSett.color}`
                        setAverageStyling(avgSett)
                    }
                }
            })
    }, [graphData])

    


    //NOTIFICATIONS


    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }));
    };


    const handlePointHover = (point):void => {
        let totalFlow = 0
        const avoidKeys = ['average', 'day', 'timeOfReading']
        Object.keys(point.target.data).forEach(key => {
            if (!avoidKeys.includes(key)) {
                totalFlow += point.target.data[key]
            }
        })
        setPointData({
            dateTime: `${moment(point.target.data.timeOfReading).format("DD-MM-yyyy hh:mm:ss A")}`,
            series: point.target.series.name === '7 Day Average' ? 'Average' : 'Total Flow',
            value: point.target.series.name === '7 Day Average' ? point.target.data.average : totalFlow
        })
    }

  
    const onDateChange = (startDateChange: Moment, endDateChange: Moment, rainfall, recent):void => {

        let finalDate = moment(endDateChange).toDate() >= moment().toDate() ? moment(endDateChange).set({hour: 0, minute: 0, second: 0}).toDate() : moment(endDateChange).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate()
        if (finalDate > moment().toDate()) {
            finalDate = moment().set({hour: 0, minute: 0, second: 0}).toDate()
        }
        const beginDate = moment(startDateChange).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
        setStartDate(beginDate)
        setEndDate(finalDate)
        if (recent) {
            setShouldReloadData(true)
        } else {
            setDateChange(true)
        }
    }

    const handleRedraw = (): void => {
        setAllValuesZero(true)
        setDateChange(false)
        reloadData(
            setLoading,
            serial,
            startDate,
            endDate,
            setAllValuesZero,
            loggers,
            useCustomColors,
            setUseCustomColors,
            setLoggers,
            setGraphData,
            siteId,
            loggerData,
            setErrorMessage,
            setOutputLoggers,
            intl
        )
        setVisualRange({startValue: startDate, endValue: endDate})
    }

    useEffect(() => {
        if (shouldReloadData) {
            handleRedraw()
            setShouldReloadData(false)
        }
    }, [startDate, endDate, shouldReloadData])

    

    const renderLoggerSeries = (logger:loggerInfo): Array<React.ReactNode> => {
 
        const loggerSeries = []
        loggerSeries.push(<Series
            valueField={logger.serial.toString()}
            color={logger.color}
            name={logger.serial}
            type="stackedbar"
        />)
        return loggerSeries
    }

    const renderCheckBox = (item:any): any => {
        const clicked = !item.series.isVisible()
        return (
            <svg>
                <rect x="0" y="0" width="18" height="18" fill="none" stroke={item.marker.fill} strokeWidth="1"></rect>
                {!clicked && <polyline points="3.5,10 8,14 14.5,4" fill="none" stroke={item.marker.fill} strokeLinecap="round" strokeWidth="2"></polyline>}
            </svg>
        );




    }

    const legendClickHandler = (e: any): void => {

        const series = e.target;
        if(series.isVisible()) {
        series.hide();
    } else {
        series.show();
        }

    }


    const customizeLegendText = (item, intl: IntlShape): string => {
        if (outputLoggers.includes(item.seriesName)) {
            return `<div style="font-size: 16px; color: black"}}>${item.seriesName}<br />${intl.formatMessage({ id: 'Output' })}</div>`
        } else {
            return `<div style="font-size: 16px; color: black"}}>${item.seriesName}</div>`
        }
        
    }

    const handleLinkDatesChecked = (): void => {
        CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF&key=Link%20Dates&value=${!linkDates}`), {})
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })
        if (linkDates) {
            setStartDate(moment().subtract(3, 'months').set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }).toDate())
            setEndDate(moment().toDate())
        } else {
            setStartDate(startDateProps)
            setEndDate(endDateProps)
        }
        setLinkDates(!linkDates)
        setShouldReloadData(true)
        
    }



    const handleEditAvg = () => {
        setShowModal(true)
        setTempAverageStyling(averageStyling)
    }

    const handleAvgWidthChange = (name: string, value: number):void => {
        const avgSett = { ...tempAverageStyling }
        if (name === 'width') {
            avgSett.width = value
        } else if (name === 'size') {
            avgSett.size = value
        }
       
        setTempAverageStyling(avgSett)
    }

    const handleColorChange = (e):void => {
        const avgSett = { ...tempAverageStyling }
        avgSett.color = e
        setTempAverageStyling(avgSett)
    }

    const handleShowPointsChange = (e):void => {
        const avgSett = { ...tempAverageStyling }
        avgSett.showPoints = e.target.checked
        setTempAverageStyling(avgSett)
    }

    const handleSaveAvgStyling = (): void => {
        const saveData = { ...tempAverageStyling }
        saveData.color = saveData.color.slice(1, 7)
        CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF&key=Custom%20Average&value=${JSON.stringify(saveData)}`), {})
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })
        setAverageStyling(tempAverageStyling)
        setShowModal(false)

    }

    const closeModal = ():void => {
        setShowModal(false)
        setTempAverageStyling(averageStyling)
    }

    const toggleTrendModal = ():void => {
        setTrendModal(!trendModal)
    }

    return (
        <div>
            {loading &&
                <div style={{
                    position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 13000
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading &&
                <div>
                    <MinimumNightFlowTrendModal
                        show={trendModal}
                        toggleTrendModal={toggleTrendModal}
                        data={graphData}
                    />
                    <Modal
                        show={showModal}
                        dialogClassName="modal-30w"
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title><FormattedMessage id="Average Line Settings" /></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                            <div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ margin: "0px 15px 0 0" }}><FormattedMessage id="Line Width" />:</p>
                                <NumberField value={tempAverageStyling.width} onValueChange={(value: number): void => handleAvgWidthChange('width', value)} size='small' fullWidth={true}  min={1} width="inherit" />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", marginTop:  "10px"}}>
                                <p style={{ margin: "0px 10px 0 0" }}><FormattedMessage id="Line Colour" />:</p>
                                        <MuiColorInput format="hex" size="small" value={tempAverageStyling.color} onChange={(e): void => handleColorChange(e)} style={{width: 220} } />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                <p style={{ margin: "0px 0px 0 0" }}><FormattedMessage id="Show Points" />:</p>
                            <Checkbox checked={tempAverageStyling.showPoints} onChange={(e): void => handleShowPointsChange(e)} />
                                {tempAverageStyling.showPoints && <div style={{ display: "flex" }} >
                                    <p style={{ margin: "8px 15px 0 15px" }}><FormattedMessage id="Size" />:</p>
                                    <NumberField value={tempAverageStyling.size} onValueChange={(value: number): void => handleAvgWidthChange('size', value)} size='small' fullWidth={true} min={1} width={120} />
                                </div>}
                                </div>
                            </div>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="contained" style={{ marginRight: "10px" }} onClick={():void => handleSaveAvgStyling() }><FormattedMessage id="Save" /></Button>
                            <Button variant="contained" color="error" onClick={(): void => closeModal()}><FormattedMessage id="Cancel" /></Button>
                        </Modal.Footer>
                    </Modal>
                    {!linkDates && <CardHeader color="primary" className="view view-cascade" style={{ paddingTop: "50px" }}>
                        <Grid container  >
                            <Grid item lg={12}  >
                                <div style={{ margin: "0px 18px 12px 25px", display: "flex" }}>
                                    <DateRange startDate={startDate} endDate={endDate} rainfall={false} onDateChange={onDateChange} type="date" showButton={dateChange} handleRedrawClick={handleRedraw} />
                                    
                                </div>
                            </Grid>
                        </Grid>
                    </CardHeader>}
                    <div style={{ marginTop: "30px", position: "relative" }}>
                        <div style={{ position: "absolute", right: "15px", display: "flex" }}>
                            <div style={{ display: "flex" }}>
                                {errorMessage && <div style={{display: "flex", justifyContent: "center", alignItems: "center", margin: "-20px 10px 0 0"} }>
                                    <div>{errorMessage}</div>
                                </div>}
                                {/*<div style={{ display: "flex", justifyContent: "center", margin: "-20px 10px 0 0" }}>*/}
                                {/*    <Button variant="contained" onClick={():void => toggleTrendModal() }><FormattedMessage id="View Trend Data"/></Button>*/}
                                {/*</div>*/}
                                <div style={{ display: "flex", justifyContent: "center", margin: "-20px 10px 0 0" }}>
                                    <TooltipMUI title={intl.formatMessage({ id: "Edit styling for average minimum night flow" })} >
                                        <Button variant="contained" color="secondary" onClick={(): void => handleEditAvg()}><FormattedMessage id="Edit Average Line" /></Button>
                                    </TooltipMUI>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "-20px" }}>
                                    <TooltipMUI title={intl.formatMessage({ id: "Finds and uses your custom colours for particular device set in graph settings" })} >
                                        <Button
                                            variant="contained"
                                            color="warning"
                                            onClick={(): void =>
                                                handleCustomColorClick(
                                                    useCustomColors,
                                                    setUseCustomColors,
                                                    loggers,
                                                    setLoggers,
                                                    serial,
                                                    siteId,
                                                    setErrorMessage,
                                                    intl)}
                                        >
                                            {useCustomColors ?
                                                intl.formatMessage({ id: 'Use Default Colours' }) :
                                                intl.formatMessage({ id: 'Use Custom Colours' })
                                            }
                                        </Button>
                                    </TooltipMUI>

                                </div>
                            </div>
                        </div>
                        <div style={{ position: "absolute", left: "5px", display: "flex" }}>
                            <div style={{ display: "flex" }}>
                                {showDateLink && <div style={{ margin: "-20px 0 0 10px" }}>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <TooltipMUI title={intl.formatMessage({ id: "Link the date to the graph above to view both in same range" })} >
                                            <Button variant="contained" onClick={(): void => handleLinkDatesChecked()}>{linkDates ? intl.formatMessage({ id: 'Undo Link dates' }) : intl.formatMessage({ id: 'Link Date to Graph' })}</Button>
                                        </TooltipMUI>

                                    </div>
                                </div>}
                                {/*Tooltip render*/}
                                {pointData && <div style={{ margin: "-20px 0 0 50px"}}>
                                    <p><b>{pointData.series}</b></p>
                                    <p><b>Value:</b> {pointData?.value.toFixed(3)} l/s</p>
                                    <p><b>Timestamp of Minimum Flow:</b> {pointData?.dateTime}</p>
                                </div>}
                            </div>
                        </div>
                        {graphData.length === 0 && <h4 style={{ textAlign: "center" }}><FormattedMessage id="No Data Available" /></h4>}
                        {graphData &&
                            graphData?.length > 0 &&
                            loggers.length > 0 &&
                            <Chart
                                dataSource={graphData}
                                ref={chartRef}
                                onLegendClick={legendClickHandler}
                                onPointHoverChanged={handlePointHover}
                                
                            >
                            <CommonSeriesSettings
                                argumentField="day"
                                ignoreEmptyPoints={false}
                                //type="stackedbar"
                            >
                                <Point size={15} />
                                <Font weight={900} size={40} />
                            </CommonSeriesSettings>

                            <ValueAxis
                                    width={2}
                                    color={loggers.length > 1 ? '#767676' : loggers[0].color}
                                    title={{ text: intl.formatMessage({ id: "Minimum Night Flow in l/s" }), font: { color: loggers.length > 1 ? '#767676' : loggers[0].color, size: 12 } }}
                                    
                            >
                                <Label font={{ color: loggers.length > 1 ? '#767676' : loggers[0].color }} />
                            </ValueAxis>
                            <CommonAxisSettings
                                valueMarginsEnabled={true}
                                minValueMargin={0.1}    //add extra 10% to show a 'gap'
                                maxValueMargin={0.1}     //add extra 10% to show a 'gap'
                            />
                            {loggers && loggers.length > 0 && loggers.map(logger => {
                                return renderLoggerSeries(logger)
                            })}
                            <Series
                                valueField="average"
                                color={averageStyling.color}
                                name={intl.formatMessage({ id: "7 Day Average" })}
                                type="spline"
                                width={averageStyling.width }
                                point={{ visible: averageStyling.showPoints, size: averageStyling.size }}
                            />

                            <ArgumentAxis
                                width={2}
                                allowDecimals={false}
                                argumentType="datetime"
                                minValueMargin={0.01}
                                maxValueMargin={0.01}
                                aggregationInterval="day"
                                visualRange={visualRange}

                            >
                                <GridChart visible={true} />
                            </ArgumentAxis>
                            <Legend
                                verticalAlignment="top"
                                horizontalAlignment="center"
                                markerRender={renderCheckBox}
                                customizeText={(data):string => customizeLegendText(data, intl)}

                            />

                            <Crosshair
                                enabled={true}
                                color="#949494"
                                width={3}
                                dashStyle="dot"
                            >
                                <Label
                                    visible={true}
                                    backgroundColor="#949494"
                                >
                                    <Font
                                        color="#fff"
                                        size={14}
                                    />
                                </Label>
                            </Crosshair>
                            <ZoomAndPan
                                allowMouseWheel={false}
                                argumentAxis="both"
                                valueAxis="none"
                                dragToZoom={true}
                            />
                            <Tooltip enabled={false}  />
                            </Chart>}
                        {allValuesZero && <p style={{position: 'absolute', top: 200, left: 725} }>Minimum Night Flow is continuously 0 l/s</p> }
                        </div>
                </div>}    
        
        </div>
    )
}

export default  MinimumNightFlow